import { InputAdornment } from '@mui/material';
import { BenefitDTOBenefitEnum, CreateBenefitActivationDTO, UpdateBenefitActivationDTO } from 'probonio-shared-ui/api';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextFieldControl } from '../../../../component/form';
import { BenefitActivationDialogExtensionInterface } from '../../../../extension/interface/benefit-activation-dialog.extension.interface';
import { ActivationDialogExtensions } from '../../ActivationDialog';

interface InternetBenefitOptions {
  monthlyBudget: number;
}

const InlineField: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const { control } = useFormContext();

  return (
    <TextFieldControl
      slotProps={{ input: { endAdornment: <InputAdornment position="end">€</InputAdornment> }, htmlInput: { step: '5' } }}
      rules={{
        required: true,
        min: 5,
        max: 50,
      }}
      type="number"
      control={control}
      variant="outlined"
      name="benefitOptions.monthlyBudget"
      label={t('INTERNET.fields.monthlyBudget')}
      margin="dense"
      fullWidth
    />
  );
};

const resetInternetBenefitOptions: ActivationDialogExtensions<InternetBenefitOptions>['onResetBenefitOptions'] = (
  selectedActivation,
): InternetBenefitOptions => {
  return {
    monthlyBudget: selectedActivation?.internetOptions ? selectedActivation.internetOptions.monthlyBudget / 100 : 50,
  };
};

const mapInternetOptions = (benefitOptions: InternetBenefitOptions) => ({
  monthlyBudget: Math.round(benefitOptions.monthlyBudget * 100),
});

const createInternetBenefitActivation: ActivationDialogExtensions<InternetBenefitOptions>['onCreateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const create: CreateBenefitActivationDTO = {
    ...baseValues,
    benefit: BenefitDTOBenefitEnum.Internet,
    internetOptions: mapInternetOptions(benefitOptions),
  };
  await saveActivation(create);
};

const updateInternetBenefitActivation: ActivationDialogExtensions<InternetBenefitOptions>['onUpdateActivation'] = async (
  baseValues,
  benefitOptions,
  saveActivation,
) => {
  const update: UpdateBenefitActivationDTO = {
    ...baseValues,
    internetOptions: mapInternetOptions(benefitOptions),
  };
  await saveActivation(update);
};

export class InternetBenefitActivationDialogExtension extends BenefitActivationDialogExtensionInterface<InternetBenefitOptions> {
  InlineField?: React.ComponentType = InlineField;

  onCreateActivation = createInternetBenefitActivation;
  onUpdateActivation = updateInternetBenefitActivation;
  onResetBenefitOptions? = resetInternetBenefitOptions;
}
